import axios from 'axios';
import { getStoredAuth, setStoredAuth , getTempAuth} from '../auth';

// Get environment variables
const API_URL = import.meta.env.VITE_APP_APISERVER;
const API_TIMEOUT = Number(import.meta.env.VITE_API_TIMEOUT) || 30000;
const cookiePrefix = import.meta.env.VITE_APP_COOKIE_PREFIX


// Create axios instance with default config
export const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Get token from storage
    const token = getStoredAuth()?.token;

    const tempToken = getTempAuth()?.token;

    // If token exists, add to headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (tempToken) {
      config.headers.Authorization = `Bearer ${tempToken}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Handle token refresh
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = getStoredAuth()?.refreshToken;
        
        if (refreshToken) {
          const response = await axiosInstance.post('/v1/accounts/business', {
            refreshToken,
          });

          const { token } = response.data;
          setStoredAuth({ token, refreshToken });

          originalRequest.headers.Authorization = `Bearer ${token}`;
          return axiosInstance(originalRequest);
        }
      } catch (error) {
        // Handle refresh token failure (e.g., logout user)
        localStorage.removeItem(`${cookiePrefix}_token`);
        localStorage.removeItem(`${cookiePrefix}_refresh_token`);
        window.location.href = '/admin/login';
      }
    }

    return Promise.reject(error);
  }
);